import { schema } from 'normalizr';

const episode = new schema.Entity('episode');

export default episode;
